import { render, staticRenderFns } from "./config.vue?vue&type=template&id=25ad32bb&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"
import style0 from "./config.vue?vue&type=style&index=0&id=25ad32bb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ad32bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25ad32bb')) {
      api.createRecord('25ad32bb', component.options)
    } else {
      api.reload('25ad32bb', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=25ad32bb&scoped=true", function () {
      api.rerender('25ad32bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/config.vue"
export default component.exports